import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Mail, ArrowRight, Loader2 } from 'lucide-react';
export function Login() {
    const { login, verify } = useAuth();
    const [step, setStep] = useState('email');
    const [email, setEmail] = useState('');
    const [code, setCode] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [devCode, setDevCode] = useState(null);
    const handleSendCode = async (e) => {
        e.preventDefault();
        if (!email.trim())
            return;
        setError('');
        setDevCode(null);
        setLoading(true);
        try {
            const res = await login(email.trim());
            if (res.success) {
                if (res.devCode) {
                    setDevCode(res.devCode);
                }
                setStep('code');
            }
            else {
                setError('Errore nell\'invio del codice');
            }
        }
        catch (err) {
            console.error('[Login] magic-code fetch error:', err);
            setError(`Errore di connessione: ${err instanceof Error ? err.message : String(err)}`);
        }
        finally {
            setLoading(false);
        }
    };
    const handleVerify = async (e) => {
        e.preventDefault();
        if (!code.trim())
            return;
        setError('');
        setLoading(true);
        try {
            const res = await verify(email.trim(), code.trim());
            if (!res.success) {
                setError('Codice non valido o scaduto');
            }
            // If success, AuthContext updates user and UI will switch to Taskpane
        }
        catch {
            setError('Errore di connessione');
        }
        finally {
            setLoading(false);
        }
    };
    return (_jsx("div", { className: "flex flex-col items-center justify-center h-screen px-4", children: _jsxs("div", { className: "w-full max-w-[280px] space-y-4", children: [_jsxs("div", { className: "text-center mb-6", children: [_jsx("h1", { className: "text-xl font-bold tracking-tight", children: "OWL" }), _jsx("p", { className: "text-xs text-muted-foreground mt-1", children: "Assistente Legale per Word" })] }), step === 'email' ? (_jsxs("form", { onSubmit: handleSendCode, className: "space-y-3", children: [_jsxs("div", { className: "relative", children: [_jsx(Mail, { className: "absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" }), _jsx("input", { type: "email", placeholder: "La tua email", value: email, onChange: (e) => setEmail(e.target.value), className: "w-full pl-9 pr-3 py-2 text-sm border rounded-md bg-background focus:outline-none focus:ring-2 focus:ring-ring", autoFocus: true, disabled: loading })] }), _jsx(Button, { type: "submit", className: "w-full", size: "sm", disabled: loading || !email.trim(), children: loading ? (_jsx(Loader2, { className: "h-4 w-4 animate-spin" })) : (_jsxs(_Fragment, { children: ["Invia codice", _jsx(ArrowRight, { className: "ml-2 h-4 w-4" })] })) })] })) : (_jsxs("form", { onSubmit: handleVerify, className: "space-y-3", children: [_jsxs("p", { className: "text-xs text-muted-foreground text-center", children: ["Codice inviato a ", _jsx("strong", { children: email })] }), devCode && (_jsxs("div", { className: "text-center py-2 px-3 bg-amber-50 border border-amber-200 rounded-md", children: [_jsx("p", { className: "text-[10px] text-amber-600 mb-1", children: "Dev mode" }), _jsx("p", { className: "text-lg font-mono font-bold tracking-[0.5em] text-amber-800", children: devCode })] })), _jsx("input", { type: "text", inputMode: "numeric", placeholder: "Codice a 6 cifre", value: code, onChange: (e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6)), className: "w-full text-center text-base tracking-[0.3em] py-2 border rounded-md bg-background focus:outline-none focus:ring-2 focus:ring-ring font-mono", autoFocus: true, disabled: loading, maxLength: 6 }), _jsx(Button, { type: "submit", className: "w-full", size: "sm", disabled: loading || code.length !== 6, children: loading ? (_jsx(Loader2, { className: "h-4 w-4 animate-spin" })) : ('Verifica') }), _jsx("button", { type: "button", onClick: () => { setStep('email'); setCode(''); setError(''); }, className: "w-full text-xs text-muted-foreground hover:text-foreground text-center", children: "Cambia email" })] })), error && (_jsx("p", { className: "text-xs text-destructive text-center", children: error })), _jsxs("p", { className: "text-[9px] text-muted-foreground text-center mt-4 break-all", children: ["origin: ", window.location.origin, _jsx("br", {}), "href: ", window.location.href, _jsx("br", {}), "protocol: ", window.location.protocol] })] }) }));
}
//# sourceMappingURL=Login.js.map